var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoltOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.125C4.30761 2.125 2.125 4.30761 2.125 7V17C2.125 19.6924 4.30761 21.875 7 21.875H17C19.6924 21.875 21.875 19.6924 21.875 17V7C21.875 4.30761 19.6924 2.125 17 2.125H7ZM3.875 7C3.875 5.27411 5.27411 3.875 7 3.875H17C18.7259 3.875 20.125 5.27411 20.125 7V17C20.125 18.7259 18.7259 20.125 17 20.125H7C5.27411 20.125 3.875 18.7259 3.875 17V7ZM15.1187 8.11872C15.4604 7.77701 15.4604 7.22299 15.1187 6.88128C14.777 6.53957 14.223 6.53957 13.8813 6.88128L9.55199 11.2106C8.93777 11.8248 9.3728 12.875 10.2414 12.875H12.3876L9.38128 15.8813C9.03957 16.223 9.03957 16.777 9.38128 17.1187C9.72299 17.4604 10.277 17.4604 10.6187 17.1187L14.948 12.7894C15.5622 12.1752 15.1272 11.125 14.2586 11.125H12.1124L15.1187 8.11872Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltOutlined);
export default __webpack_public_path__ + "static/media/bolt-outlined.26f8470bcb5b28a506645049b1963210.svg";
export { ForwardRef as ReactComponent };